import { GTMState } from 'types/store/GTMState';
import { createUpdateAction, createClearAction } from 'utils/Redux';

const ns = 'GTM_INTEGRATION';
const updateAction = createUpdateAction<GTMState>(ns);
const clearAction = createClearAction(ns);

const GTMActions = {
  ...updateAction,
  ...clearAction,
};

export default GTMActions;
